export const Ton = () => 't';
